export default __webpack_public_path__ + "static/media/chapterWebsite2Low.cacd77fc.jpg";